import { render, staticRenderFns } from "./QualificationReview.vue?vue&type=template&id=718b98d6&scoped=true&"
import script from "./QualificationReview.vue?vue&type=script&lang=js&"
export * from "./QualificationReview.vue?vue&type=script&lang=js&"
import style0 from "./QualificationReview.vue?vue&type=style&index=0&id=718b98d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b98d6",
  null
  
)

export default component.exports